export default __webpack_public_path__ + "static/media/include_11@3x.2b85dbe5.jpg";